import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Layout from '@/layout'

// 动态路由相关导入
import DynamicRouteUtils from '@/utils/dynamicRoute'


Vue.use(Router)

export const constantRoutes = [

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/sso-login',
    component: () => import('@/views/login/SsoLogin'),
    hidden: true
  },
  {
    path: '/lab/sampleRegistration/view_offince',
    component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/view_offince'),
    hidden: true
  },
  {
    path: '/lab/sampleDispense/sampleRegistration/processCard',
    component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/processCard'),
    funcPerms: 'lab:sample:register',
    name: 'processCard',
    hidden: true,
    meta: {
      title: '流程卡',
      icon: 'index',
      affix: false,
      noCache: true
    }
  },
  {
    path: '/lab/DetectionTask/office',
    component: () => import('@/views/lab/DetectionTask/office'),
    hidden: true
  },
  {
    path: '/m/sample-registration',
    component: () => import('@/views/mobile/sampleRegistration/index.vue'),
    hidden: true
  },
  // {
  //   path: '/welcome',
  //   component: () => import('@/views/home/welcome.vue'),
  //   hidden: true
  // },
  // {
  //   path: '/baseIndex',
  //   component: () => import('@/views/dashboard/base/index'),
  //   name: 'BaseWelcome',
  //   meta: { title: '首页', icon: 'dashboard', affix: true }
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/welcome',
    component: () => import('@/views/home/welcome'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/welcome',
    hidden: true

  }

]
// 404路由将通过动态路由系统添加

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

let router = createRouter()

/**
 * 重置路由
 */
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

/**
 * 动态添加路由
 * @param {Array} routes - 路由配置数组
 */
export function addDynamicRoutes(routes) {
  if (!routes || !Array.isArray(routes)) {
    console.warn('动态路由配置无效:', routes)
    return
  }

  // Vue Router 3.x 使用 addRoutes 方法
  const validRoutes = routes.filter(route => {
    if (DynamicRouteUtils.validateRoute(route)) {
      return true
    } else {
      console.warn('无效的路由配置:', route)
      return false
    }
  })
  
  if (validRoutes.length > 0) {
    router.addRoutes(validRoutes)
  }
}

/**
 * 生成动态路由
 * @param {string} system - 系统标识
 */
export async function generateDynamicRoutes(system = 'oa') {
  try {
    // 通过store获取动态路由
    const routes = await store.dispatch('dynamicRoute/generateRoutes', system)
    
    // 添加到路由实例
    addDynamicRoutes(routes)
    
    console.log(`${system}系统动态路由生成成功:`, routes)
    return routes
  } catch (error) {
    console.error('生成动态路由失败:', error)
    throw error
  }
}

/**
 * 切换系统路由
 * @param {string} system - 系统标识
 */
export async function switchSystemRoutes(system) {
  try {
    // 重置路由
    resetRouter()
    
    // 重新创建路由实例
    router = createRouter()
    
    // 生成新系统的路由
    await generateDynamicRoutes(system)
    
    console.log(`切换到${system}系统成功`)
  } catch (error) {
    console.error(`切换到${system}系统失败:`, error)
    throw error
  }
}

// 动态路由系统已集成到store中，不再需要单独的切换函数

export default router
